var map = {
	"./at.jpg": 6288,
	"./atortho.jpg": 93360,
	"./esri.jpg": 7476,
	"./fauna.jpg": 56288,
	"./icgc.jpg": 15029,
	"./icgcortho.jpg": 87303,
	"./ign.jpg": 81905,
	"./ignes.jpg": 65969,
	"./ignesortho.jpg": 66051,
	"./ignortho.jpg": 99395,
	"./ignslopes.jpg": 35457,
	"./opentopomap.jpg": 57949,
	"./swisstopo.jpg": 95702,
	"./swisstopoortho.jpg": 77478,
	"./swisstoposlopes.jpg": 61774,
	"./uk.jpg": 85084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13059;